// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"PortfolioNavigation_layoutSwitch__sJWt2","paginationSwitch":"PortfolioNavigation_paginationSwitch__I8bQg"};